export const sd = {
  spiel: [
    11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
    53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,99,
    11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
    53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,99,
    11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
    53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,99,
    11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
    53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,99
  ],
  index: [11,21,31,41,51,61,71,81,91,12,22,32,42,52,62,72,82,92,13,23,33,43,53,63,73,83,93,14,24,34,44,54,64,74,84,94,99],
  code: '0123456789abcdefghijklmnopqrstuvwxyz_',
  stein: null,
  zuege: null,
  idx: 0,
  gleich(s1, s2) {
    return s1.i === s2.i && s1.x === s2.x && s1.y === s2.y;
  },
  leer(s) {
    return s.i === 0;
  },
  paar3Linien(feld, s1, se, stufe, richtung) {
    if ( stufe > 2 ) {
      return false;
    }
    let s2 = null, x = 0, y = 0, o = 0;
    if ( richtung !== 'x') {
      o = -1;
      while ( o < 2) {
        x = s1.x, y = s1.y;
        while (x + o >= 0 && x + o <= 19 ) {
          x = x + o;
          s2 = { x: x, y: y, i: feld[y][x].i };
          if ( sd.gleich( se, s2 )) {
            return true;
          } else if ( sd.leer(s2) ) {
            if ( sd.paar3Linien(feld, s2, se, stufe + 1, 'x') ){
              return true;
            }
          } else {
            break;
          }
        }
        o = o + 2;
      }
    }
    if ( richtung !== 'y') {
      o = -1;
      while ( o < 2) {
        x = s1.x, y = s1.y;
        while (y + o >= 0 && y + o <= 9 ) {
          y = y + o;
          s2 = { x: x, y: y, i: feld[y][x].i };
          if ( sd.gleich( se, s2 )) {
            return true;
          } else if ( sd.leer(s2) ) {
            if ( sd.paar3Linien(feld, s2, se, stufe + 1, 'y') ){
              return true;
            }
          } else {
            break;
          }
        }
        o = o + 2;
      }
    }
    return false;
  },
  getPos(w, feld) {
    const pos = [];
    for( let y = 1; y < 10; y++ ) {
      for( let x = 1; x < 19; x++ ) {
        if ( feld[y][x].i === w ) {
          pos.push( {x: x, y: y, i: w} );
        }
      }
    }
    return pos
  }
}
